<ngx-material-intl-tel-input
  [fieldControl]="phoneControl()"
  [required]="true"
  [autoSelectedCountry]="CountryISO.Brazil"
  [autoIpLookup]="false"
  [hidePhoneIcon]="true"
  [visibleCountries]="[
    CountryISO.Brazil,
    CountryISO.Paraguay
  ]"
  [preferredCountries]="[
    CountryISO.Brazil,
    CountryISO.Paraguay,
  ]"
  appearance="fill"
  [outputNumberFormat]="0"
  [textLabels]="textLabels()">
</ngx-material-intl-tel-input>
@if (showValidations() && phoneControl().invalid && (phoneControl().touched || phoneControl().dirty)) {
  <div class="validations">
    @if (phoneControl().hasError('required')) {
      <mat-error>{{ 'PORTAL.WAITING_LIST.PHONE.REQUIRED' | translate }}</mat-error>
    } @else if (phoneControl().hasError('invalidNumber')) {
      <mat-error>{{ 'PORTAL.WAITING_LIST.PHONE.INVALID' | translate }}</mat-error>
    }
  </div>
}
